import { useQuery } from '@tanstack/react-query';
import type { components } from '@/api/schema';
import i18n from '@/i18n';

export type Region = components['schemas']['RegionResource'];
export type District = components['schemas']['DistrictResource'];

export function useRegions() {
  return useQuery({
    queryKey: ['/regions'],
    select: (resp: { data?: Region[] }) => resp?.data ?? [],
    staleTime: 1000 * 60 * 60,
  });
}

export function useDistricts(regionId?: number | string | null) {
  return useQuery({
    queryKey: ['/regions/{region}/districts', { params: { path: { region: Number(regionId) } } }],
    select: (resp: { data?: District[] }) => resp?.data ?? [],
    enabled: !!regionId,
    staleTime: 1000 * 60 * 60,
  });
}

/** FR-64: flat list, used where a saved region_id isn't known up-front. */
export function useAllDistricts() {
  return useQuery({
    queryKey: ['/districts'],
    select: (resp: { data?: District[] }) => resp?.data ?? [],
    staleTime: 1000 * 60 * 60,
  });
}

export const BRANCH_STATUSES = [
  { value: 'active', get label() { return i18n.t('misc_geo.st_active'); } },
  { value: 'inactive', get label() { return i18n.t('misc_geo.st_inactive'); } },
  { value: 'closed', get label() { return i18n.t('misc_geo.st_closed'); } },
  { value: 'pending', get label() { return i18n.t('misc_geo.st_pending'); } },
] as const;

export const branchStatusLabel = (v?: string | null) =>
  BRANCH_STATUSES.find(s => s.value === v)?.label || i18n.t('misc_geo.st_active');
